import { getShareIdByPermissionType } from "@/components/Joyspace/api/permissions";
import { joyspacePermissionType } from "@/components/Joyspace/config/permissions.config";
import { sizeToStr } from "@/components/UploadBox/utils";
import { useNavigator } from "@/utils/NetworkCheck";
import { BatchDownloadItem, ErrorCode, Status } from "../type";
import { lookup } from "mime-types";
import { getFileIconByMime } from "@/utils/chat/index";
import { changeEgovUrl } from "@/utils/tools";

const checkNetworkLine = (options: any) => {
  !useNavigator.onLine && options.onError(ErrorCode.NETWORK_ERROR);
  return useNavigator.onLine;
};

const checkDownloadPermission = (pageId: string, options: any) => {
  const currentPermission: any = getShareIdByPermissionType(pageId);
  if (currentPermission === joyspacePermissionType.ReadDel) {
    options.onError(ErrorCode.NO_PERMISSION);
    return false;
  }
  return true;
};

const checkDownloadError = (pageId: string, options: any) => {
  return checkNetworkLine(options) && checkDownloadPermission(pageId, options);
};

const convertDownloadUnit = (totalBytes: number) => {
  return sizeToStr(totalBytes);
};

const createDownloadItem = (item: any) => {
  const [fileIcon] = getFileIconByMime(lookup(item.name) || "");
  return {
    ...item,
    id: item.id,
    name: item.name,
    currentSize: "0kb",
    url: item.url,
    size: convertDownloadUnit(Number(item.size || 0)),
    currentProgress: 0,
    status: Status.WAITING,
    index: 0,
    applyFn: Status.WAITING,
    path: item.path,
    gid: item.gid,
    onProgress: () => {},
    onStart: () => {},
    imgUrl: fileIcon
  };
};

const getDownloadFileStatus = async (url: string): Promise<number> => {
  return new Promise((resolve) => {
    let xhr = new XMLHttpRequest();
    xhr.open("GET", url, true);
    xhr.onload = function () {
      resolve(this.status);
    };
    xhr.send();
  });
};

// // 截取文档标题
// const substringPageTitle = (title = '') => {
//     let len = title.length;
//     if (len <= 150) {
//         return title || '';
//     }
//     let startStr = title.substring(0, 25);
//     let lastIndex = len - 25;
//     let endStr = title.substring(lastIndex, len);
//     // eslint-disable-next-line no-debugger
//     // debugger;
//     console.log(startStr, 'startStrstartStrstartStrstartStrstartStr');
//     console.log(endStr, 'endStrendStrendStrendStrendStrendStrendStr');
//     console.log(lastIndex, 'lastIndexlastIndexlastIndexlastIndex', len, title);
//     return `无标题.txt`;
// };

export {
  checkNetworkLine,
  checkDownloadPermission,
  checkDownloadError,
  convertDownloadUnit,
  createDownloadItem,
  getDownloadFileStatus
  // substringPageTitle,
};
